
import { ApplicationUserModel, AuditTimingModel, GroupModel, GroupUserModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { groupsStore } from '@/libs/groups/+state/store';
import GroupUserList from '@/libs/settings/components/GroupUserList.vue';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { auditTimingsStore } from '@/libs/audit-timings/+state/store';
import { groupUsersStore } from '@/libs/group-users/+state/store';

@Component({
    components: {
        GroupUserList,
    },
})
export default class GroupDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    group: GroupModel | null = null;
    deleteDialog = false;
    deleting = false;
    canDelete = false;

    get exceptUsers(): string[] {
        return this.group?.groupUsers?.select((x) => x.tenantUserId!).toArray() ?? [];
    }

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.group?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadRole()
                    .then((e) => {
                        const group = e as GroupModel;
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.group = {
                id: Guid.EmptyGuid(),
                name: '',
                groupUsers: [],
            } as GroupModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadRole() {
        return new Promise((resolve, reject) => {
            groupsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(groupsStore, CrudReponse.Get)
                .then((e) => {
                    this.group = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const group = { ...this.group };
            group.groupUsers = group
                .groupUsers!.where((x) => x.tenantUserId != null && x.tenantUserId != Guid.EmptyGuid())
                .toArray();
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                groupsStore.dispatch(CrudAction.Create, { item: group });
                this.subscribe(groupsStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                groupsStore.dispatch(CrudAction.Update, { item: group });
                this.subscribe(groupsStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        groupUsersStore.dispatch(
            CrudAction.GetAll,
            createCrudQueryPayload<GroupUserModel>(
                undefined,
                [{ field: 'groupId', op: 'eq', comparand: this.group!.id! }],
                undefined,
                false,
                'RoleDelete'
            )
        );
        this.subscribe(groupUsersStore, CrudReponse.GetAll, 'RoleDelete').then((e: GroupUserModel[]) => {
            this.canDelete = e.length == 0;
            this.deleteDialog = true;
        });
    }

    deleteRole() {
        this.deleting = true;
        groupsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(groupsStore, CrudReponse.Delete)
            .then((e: any) => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch((e: any) => {
                this.deleting = false;
            });
    }
}
